import React from "react";
import Slider from "react-slick";
import { FaArrowRight, FaStar } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";

const GOOGLE_REVIEWS_URL =
    "https://www.google.com/maps/place/Rudnik+Sitarjevec/@46.0498295,14.8303195,17z/data=!4m6!3m5!1s0x47653cf8a1424b4d:0x5cd724a8dab855f3!8m2!3d46.0498295!4d14.8303195!16s%2Fg%2F11f4j8q3f4";

const sliderSettings = {
    accessibility: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 4500,
    dots: true,
    infinite: true,
    pauseOnFocus: true,
    pauseOnHover: false,
    slidesToScroll: 1,
    slidesToShow: 3,
    speed: 500,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                slidesToShow: 1.1,
            },
        },
    ],
};

function ReviewStars({ label }) {
    return (
        <div className="google-review-card__stars" aria-label={label}>
            {[0, 1, 2, 3, 4].map((star) => (
                <FaStar key={star} aria-hidden="true" />
            ))}
        </div>
    );
}

function GoogleReviewCard({ review, labels }) {
    const initial = Array.from(review.author)[0].toUpperCase();

    return (
        <div className="google-review-card-wrapper">
            <article className="google-review-card">
                <div className="google-review-card__header">
                    <div
                        className={`google-review-card__avatar${
                            review.image
                                ? " google-review-card__avatar--image"
                                : ""
                        }`}
                        aria-hidden="true"
                    >
                        {review.imageViewBox ? (
                            <svg
                                viewBox={review.imageViewBox}
                                focusable="false"
                            >
                                <image
                                    href={review.image}
                                    width={review.imageWidth}
                                    height={review.imageHeight}
                                />
                            </svg>
                        ) : review.image ? (
                            <img
                                src={review.image}
                                alt=""
                                width="48"
                                height="48"
                                loading="lazy"
                            />
                        ) : (
                            initial
                        )}
                    </div>
                    <div className="google-review-card__author">
                        <h3>{review.author}</h3>
                        <ReviewStars label={labels.fiveStars} />
                    </div>
                    <FcGoogle
                        className="google-review-card__google-icon"
                        aria-label="Google"
                    />
                </div>

                <blockquote className="google-review-card__quote">
                    <p>{review.excerpt || review.quote}</p>
                </blockquote>

                {review.excerpt && (
                    <details className="google-review-card__details">
                        <summary>{labels.readFullReview}</summary>
                        <p>{review.quote}</p>
                    </details>
                )}
            </article>
        </div>
    );
}

function GoogleReviews({ title, description, reviews, labels }) {
    return (
        <section className="google-reviews ptb--120" aria-labelledby="google-reviews-title">
            <div className="container">
                <div className="google-reviews__heading">
                    <div>
                        <h2 id="google-reviews-title">{title}</h2>
                        <p>{description}</p>
                    </div>
                    <a
                        className="google-reviews__source"
                        href={GOOGLE_REVIEWS_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FcGoogle aria-hidden="true" />
                        <span className="google-reviews__score">
                            <strong>4.8</strong>
                            <FaStar aria-hidden="true" />
                        </span>
                        <span>{labels.googleLink}</span>
                        <FaArrowRight aria-hidden="true" />
                    </a>
                </div>

                <div className="google-reviews__slider">
                    <Slider {...sliderSettings}>
                        {reviews.map((review) => (
                            <GoogleReviewCard
                                key={review.author}
                                review={review}
                                labels={labels}
                            />
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    );
}

export default GoogleReviews;
